import { yellow, grey, purple } from '@mui/material/colors';

export const SchedulesStyles = () => {
    return {
        "& .MuiDataGrid-columnHeaderTitleContainer": {
            justifyContent: "center",

            "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold",
            }
        },
        "& .salary-table": {
            "&__title": {
                margin: "20px auto 0",
                fontWeight: "bold",
                textAlign: "center",
            },
            "&__notes": {
              "& span":{
                  background: `${purple[50]}`,
                  display: "inline-block",
                  marginRight: "6px",
                  height: "20px",
                  width: "20px"
              }
            }
        },
        "& .step-cell": {
            background: `${yellow[100]}`,
        },
        "& .salary-column": {
            display: "flex !important",
            justifyContent: "space-around !important",

            "&.ba-column": {
              borderRight: `1px dotted ${grey[400]}`
            },

            "&.calculated_index": {
                background: `${purple[50]}`,
            },
            "& .salary-value": {
                fontWeight: "bold",
            }
        },
        "& .editors-notes": {
            ".label": {
                fontWeight: "bold"
            },
            "ul": {
                marginTop: 0,
            }
        }
    }
}